<template>
  <div style="margin-bottom:30px;">
    <el-form-item :prop="elementDefinition.key" :label="elementDefinition.label">
      <el-popover
                v-if="elementDefinition.instructions"
                placement="top-start"
                :title="elementDefinition.key"
                width="500"
                trigger="hover"
                :content="elementDefinition.instructions"
        >
            <i class="el-icon-info" slot="reference"></i>
        </el-popover>
        <el-checkbox v-if="edit_mode !== false" v-model="selectedValue" @change="handleChange"></el-checkbox>
        <div v-else class="form-readonly-value">{{ selectedValue ? 'Yes' : 'No' }}</div>
    </el-form-item>
  </div>
</template>

<script>
    export default {
        name: "FormElementBoolean",
        props: [
            'elementDefinition',
            'initialValue',
            'handleFormElementValueChange',
            'edit_mode'
        ],
        data() {
            return {
                selectedValue: null,
            }
        },
        mounted() {
            // Always emit true/false, never null
            this.selectedValue = this.initialValue === null || this.initialValue === undefined ? false : Boolean(this.initialValue)
            // Always emit initial value so parent knows about the field
            this.handleChange(this.selectedValue)
        },
        watch: {
            initialValue: function(val) {
                this.selectedValue = !!val
            }
        },
        methods: {
            handleChange(stringValue) {
                console.log('in handleChange in FormElementBoolean')
                let field_name = this.elementDefinition.key
                let field_value = stringValue ? true : false
                console.log('in handleChange, about to emit')
                this.$emit('handleFormElementValueChange', {field_value, field_name})
                console.log('in handleChange, emitted')
            },
        }
    }
</script>

<style scoped>

</style>